(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout;
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r = [], a = false, n = null;
  const i = (e2) => Date.now() - e2 > 3e5, c = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: a2 }) => {
    try {
      const n2 = `https://${e2}/api/2024-07/graphql.json`, i2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, c2 = await fetch(n2, { method: "POST", headers: i2, body: JSON.stringify({ query: r2, variables: a2 }) });
      return await c2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, o = async (c2, o2, l2, p2, u2, d2) => {
    const m2 = ((e2, t2, r2, a2, n2) => `${e2}:${t2}:${r2}:${JSON.stringify(a2)}:${n2}`)(c2, l2, p2, u2, d2), y2 = e.get(m2);
    if (y2 && !i(y2.timestamp)) return y2.data;
    const g2 = t.get(m2);
    if (g2) return g2;
    const P2 = (f = { shopDomain: c2, accessToken: o2, handle: l2, customerGroupId: p2, customerTags: u2, clayCountryIsoCode: d2, cacheKey: m2 }, new Promise((e2, t2) => {
      r.push({ ...f, resolve: e2, reject: t2 }), a || (a = true, queueMicrotask(() => {
        a = false, function() {
          if (0 === r.length) return;
          const e3 = r;
          r = [];
          for (let t3 = 0; t3 < e3.length; t3 += 10) {
            const r2 = e3.slice(t3, t3 + 10), a2 = null === n, i2 = s(r2, a2);
            a2 && (n = i2);
          }
        }();
      }));
    }));
    var f;
    return t.set(m2, P2), P2.finally(() => {
      t.delete(m2);
    }), P2;
  };
  async function s(t2, r2) {
    var _a, _b, _c;
    if (!r2 && n) try {
      await n;
    } catch {
    }
    const a2 = t2[0];
    try {
      const r3 = `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${t2.map((e2) => e2.handle).map((e2, t3) => `p${t3}: product(handle: ${JSON.stringify(e2)}) {
      title
      handle
      variants(first: 50) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n")}
  }`, n2 = await c({ shopDomain: a2.shopDomain, accessToken: a2.accessToken, query: r3, variables: { country: a2.clayCountryIsoCode } });
      if (!(n2 == null ? void 0 : n2.data)) {
        const e2 = new Error("Empty response from Storefront API");
        return void t2.forEach((t3) => t3.reject(e2));
      }
      for (let r4 = 0; r4 < t2.length; r4++) {
        const a3 = t2[r4], i2 = n2.data[`p${r4}`];
        if (!i2) {
          const t3 = { handle: a3.handle, allVariants: [] };
          e.set(a3.cacheKey, { data: t3, timestamp: Date.now() }), a3.resolve(t3);
          continue;
        }
        if ((_b = (_a = i2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          p(a3.shopDomain, a3.accessToken, a3.handle, a3.customerGroupId, a3.customerTags, a3.clayCountryIsoCode, a3.cacheKey).then((e2) => a3.resolve(e2)).catch(a3.reject);
          continue;
        }
        const c2 = (((_c = i2.variants) == null ? void 0 : _c.edges) || []).map((e2) => l(e2.node, a3.customerGroupId, a3.customerTags)), o2 = { handle: a3.handle, allVariants: c2 };
        e.set(a3.cacheKey, { data: o2, timestamp: Date.now() }), a3.resolve(o2);
      }
      u();
    } catch (e2) {
      console.error("Error in batched product metafield fetch:", e2), t2.forEach((t3) => t3.reject(e2));
    }
  }
  function l(e2, t2, r2) {
    var _a;
    const a2 = e2.id.split("/").pop(), n2 = (_a = e2.metafield) == null ? void 0 : _a.value, i2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const t3 = e3[0];
      if ("customerGroupId" in t3) return r3 = e3, Array.isArray(r3) ? r3.map((e4 = {}) => {
        const { customerGroupId: t4 = "", customerTag: r4 = "", type: a3 = "WHOLESALE", wholesalePrice: n3 = null, quantityPrice: i3 = {} } = e4;
        let c3 = false;
        "QUANTITY" === a3 && (c3 = !!i3.isVariantUnique);
        let o3 = [];
        return "WHOLESALE" === a3 && null != n3 ? o3.push({ quantity: "1", price: n3 }) : Array.isArray(i3.value) && (o3 = i3.value), { ownerId: "", customerGroupId: t4, customerTag: r4, markets: [{ handle: "", currency: "", pricing: { type: o3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: c3, priceSource: "R", values: o3 } }] };
      }) : [];
      var r3;
      if ("i" in t3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const t4 = e4.map((e5 = {}) => {
          let t5 = e5.o || "", [r4 = "", a3 = ""] = (e5.i || "").split("~");
          return { ownerId: t5, customerGroupId: r4, customerTag: a3, markets: e5.p.split("|").map((e6) => {
            let [t6 = "", r5 = "", a4 = "A", n3 = "0", i3 = "R", c3 = ""] = e6.split("~"), o3 = c3.split(";").map((e7) => {
              let [t7 = "1", r6 = "0"] = e7.split(":");
              return { quantity: t7, price: r6 };
            }) ?? [];
            return { handle: t6, currency: r5, pricing: { type: o3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: a4, priceSource: i3, isVariantUnique: "1" === n3, values: o3 } };
          }) };
        });
        return t4;
      }(e3);
      return [];
    }("string" == typeof n2 ? JSON.parse(n2) : []);
    let c2 = i2.find((e3) => e3.customerGroupId === t2 && !["LOGGED_IN", "ALL"].includes(t2) || r2.includes(e3.customerTag));
    c2 || "ALL" === t2 || (c2 = i2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), c2 || (c2 = i2.find((e3) => "ALL" === e3.customerGroupId));
    const o2 = window.clayMarketHandle;
    if (c2) {
      const t3 = c2.markets.find((e3) => e3.handle === o2 || "" === e3.handle) || null;
      if (t3) {
        const r3 = { ...c2, markets: [t3] };
        if ("" === r3.ownerId || r3.ownerId === a2.split("/").pop()) return { id: a2, title: e2.title, pricingRule: r3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: a2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function p(t2, r2, a2, n2, i2, o2, s2) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    try {
      let p2, d2 = true;
      const m2 = [];
      for (; d2; ) {
        const u2 = await c({ shopDomain: t2, accessToken: r2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${p2 ? `"${p2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: a2, country: o2 } });
        if (!((_a = u2.data) == null ? void 0 : _a.product)) {
          const t3 = { handle: a2, allVariants: [] };
          return e.set(s2, { data: t3, timestamp: Date.now() }), t3;
        }
        const y3 = (((_b = u2.data.product.variants) == null ? void 0 : _b.edges) || []).map((e2) => l(e2.node, n2, i2));
        m2.push(...y3), d2 = (_f = (_e = (_d = (_c = u2.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e.pageInfo) == null ? void 0 : _f.hasNextPage, p2 = (_j = (_i = (_h = (_g = u2.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const y2 = { handle: a2, allVariants: m2 };
      return e.set(s2, { data: y2, timestamp: Date.now() }), u(), y2;
    } catch (e2) {
      throw console.error("Error fetching product metafield:", e2), e2;
    }
  }
  const u = () => {
    for (const [t2, r2] of e.entries()) i(r2.timestamp) && e.delete(t2);
  };
  function d(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, a2 = r2.toFixed(2), n2 = r2.toFixed(0), i2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), o2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = a2.replace(".", ","), p2 = i2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), u2 = o2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return t2.replace("{{amount}}", a2).replace("{{amount_no_decimals}}", n2).replace("{{amount_with_comma_separator}}", i2).replace("{{amount_no_decimals_with_comma_separator}}", c2).replace("{{amount_with_period_separator}}", o2).replace("{{amount_no_decimals_with_period_separator}}", s2).replace("{{amount_with_comma_decimal}}", l2).replace("{{amount_with_comma_separator_and_comma_decimal}}", p2).replace("{{amount_with_period_separator_and_comma_decimal}}", u2);
  }
  function m(e2, t2, r2) {
    var _a;
    let a2 = "", n2 = "", i2 = "", c2 = "", o2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!o2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let s2 = o2.pricing.type;
    return "QUANTITY" === s2 ? { retailPriceText: a2, compareAtPriceText: n2, savingsText: i2, maxRetailPriceText: c2 } = function(e3, t3, r3, a3) {
      let n3 = a3.pricing.strategy, i3 = a3.pricing.values, c3 = a3.currency, o3 = e3.price.currencyCode, s3 = "R" === a3.pricing.priceSource ? e3.price.amount : "C" === a3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!s3 || "" === s3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let p2 = i3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (c3 !== o3 && "" !== c3) {
        if (!l2 || !l2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (p2 = (parseFloat(p2) * l2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? p2 : "P" === n3 ? (parseFloat(s3) * (1 - parseFloat(p2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(s3) - parseFloat(p2)).toFixed(2).toString() : e3.price.amount;
      if ("" === c3 && l2 && l2.base_currency !== o3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let m2 = d(u2, clayProductPriceConfig.priceDisplayText), y2 = d(s3, clayProductPriceConfig.compareAtPriceDisplayText), g2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(s3) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(s3) - parseFloat(u2)) / parseFloat(s3) * 100).toFixed(2) : 0, P2 = d(g2, clayProductPriceConfig.savingsDisplayText);
      return l2 && (m2 = window.clayCurrencySymbol + parseFloat(u2).toFixed(2) + " " + window.clayCountryCurrency, y2 = window.clayCurrencySymbol + parseFloat(s3).toFixed(2) + " " + window.clayCountryCurrency, P2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + g2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? g2 + "%" : "")), { retailPriceText: m2, compareAtPriceText: y2, savingsText: P2, maxRetailPriceText: "" };
    }(e2, 0, r2, o2) : "WHOLESALE" === s2 && ({ retailPriceText: a2, compareAtPriceText: n2, savingsText: i2, maxRetailPriceText: c2 } = function(e3, t3, r3) {
      let a3 = r3.pricing.strategy;
      r3.pricing.values;
      let n3 = r3.currency, i3 = e3.price.currencyCode, c3 = window.marketConversionRate, o3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s3 = r3.pricing.values[0].price;
      if (!o3 || "" === o3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (n3 !== i3 && "" !== n3) {
        if (!c3 || !c3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(a3) && (s3 = (parseFloat(s3) * c3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === a3 ? s3 : "P" === a3 ? (parseFloat(o3) * (1 - parseFloat(s3) / 100)).toFixed(2).toString() : "F" === a3 ? (parseFloat(o3) - parseFloat(s3)).toFixed(2).toString() : e3.price.amount;
      if ("" === n3 && c3 && c3.base_currency !== i3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let p2 = d(l2, clayProductPriceConfig.priceDisplayText), u2 = d(o3, clayProductPriceConfig.compareAtPriceDisplayText), m2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(o3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(o3) - parseFloat(l2)) / parseFloat(o3) * 100).toFixed(2) : 0, y2 = d(m2, clayProductPriceConfig.savingsDisplayText);
      return c3 && (p2 = window.clayCurrencySymbol + parseFloat(l2).toFixed(2) + " " + window.clayCountryCurrency, u2 = window.clayCurrencySymbol + parseFloat(o3).toFixed(2) + " " + window.clayCountryCurrency, y2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + m2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? m2 + "%" : "")), { retailPriceText: p2, compareAtPriceText: u2, savingsText: y2, maxRetailPriceText: "" };
    }(e2, 0, o2)), { retailPriceText: a2, compareAtPriceText: n2, savingsText: i2, maxRetailPriceText: c2 };
  }
  const y = { productGrid: ".product-grid .custom-card", productGridProductUrl: ".custom-card-link", productGridProductPrice: ".price", retailPriceBlockFormatOnCollectionsPage: '<div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">{retailPriceText}</span></div></div>', comparePriceBlockFormatOnCollectionsPage: '<div class="price__container"><div class="price__sale"><span><s class="price-item price-item--regular">{compareAtPriceText} </s></span><span class="price-item price-item--sale price-item--last">{retailPriceText}</span></div></div>' };
  async function g() {
    P(0, 1e4);
  }
  function P(e2, t2, r2) {
    let a2 = document.querySelectorAll(y.productGrid);
    !function(e3) {
      e3.forEach(async (e4, t3) => {
        var _a;
        const r3 = (_a = e4.querySelector(y.productGridProductUrl)) == null ? void 0 : _a.href;
        if (!r3) return;
        let a3 = function(e5) {
          if (!e5 || "" === e5) return null;
          let t4 = null;
          const r4 = e5.match(/\/products\/([^/?#]+)/);
          return r4 && r4[1] && (t4 = decodeURIComponent(r4[1])), t4;
        }(r3);
        const n2 = e4.querySelector(y.productGridProductPrice);
        if (!n2 || n2.classList.contains("clay-wholesale-price")) return;
        const i2 = await async function(e5) {
          const t4 = window.clayStorefrontConfig || {}, r4 = window.clayCustomerTier || {}, a4 = window.clayCustomerTags || [], n3 = window.clayCountryIsoCode, { allVariants: i3 } = await o(t4.shopDomain, t4.token, e5, "" === r4.customerGroupId ? "LOGGED_IN" : r4.customerGroupId, a4, n3);
          return i3;
        }(a3);
        !async function(e5, t4, r4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const a4 = e5[0];
          if (!a4.pricingRule) return;
          const n3 = t4.querySelector(r4.productGridProductPrice), { retailPriceText: i3, compareAtPriceText: c2, savingsText: o2 } = m(a4, 0, 1);
          if ("" === i3) return;
          let s2 = function(e6, t5, r5, a5, n4) {
            return e6.replace("{retailPriceText}", t5).replace("{compareAtPriceText}", r5).replace("{savingsText}", a5).replace("{maxRetailPriceText}", n4);
          }(i3 !== c2 ? r4.comparePriceBlockFormatOnCollectionsPage : r4.retailPriceBlockFormatOnCollectionsPage, i3, c2, o2, "");
          n3.classList.contains("clay-wholesale-price") || (n3.innerHTML = s2, n3.classList.add("clay-wholesale-price"));
          i3 === c2 || n3.classList.contains("price--on-sale") ? i3 === c2 && n3.classList.contains("price--on-sale") && n3.classList.remove("price--on-sale") : n3.classList.add("price--on-sale");
        }(i2, e4, y);
      });
    }(a2), e2 < t2 && setTimeout(() => {
      P(e2 + 200, t2, a2.length);
    }, 200);
  }
  !async function() {
    !function() {
      window.addEventListener("popstate", g);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), g();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), g();
      }, g();
    }();
  }();
}();
